import React, { ComponentProps, FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { InputLayout } from 'record-it-components/input/InputLayout/InputLayout';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { prepareProps } from 'record-it-components/utils/propUtils';

import { WorkTimeEntry } from '../../../classes/entities/WorkTimeEntry/workTimeEntryTypes';

export type WorkTimeEntryNoteWidgetProps = PropsWithoutChildren<
  ComponentProps<'div'>
> & { workTimeEntry: WorkTimeEntry };

export const WorkTimeEntryNoteWidget: FunctionComponent<WorkTimeEntryNoteWidgetProps> =
  React.memo((props) => {
    const { workTimeEntry, ...remainingProps } = prepareProps({
      props,
      ignoreChildren: true
    });

    const { t } = useTranslation();

    return (
      <div {...remainingProps}>
        <InputLayout
          label={t('components.workTime.WorkTimeEntryNoteWidget.label')}
        >
          {() => (
            <div>
              {workTimeEntry.note ||
                t('components.workTime.WorkTimeEntryNoteWidget.noNote')}
            </div>
          )}
        </InputLayout>
      </div>
    );
  });
